import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import type { State } from 'state';
import { exitTestModeAction } from 'state/actions/login';
import { getLoginUIState } from 'state/selectors/login';
import SsoTestModeBanner from './sso-test-mode-banner';

const selector = createSelector(
    (state: State) => getLoginUIState(state).email,
    (email) => ({
        email,
    })
);

export default connect(selector, {
    onExitTestMode: exitTestModeAction,
})(SsoTestModeBanner);
